import { makeApiCall } from "../lib/api/helpers";
import {
  getTransactionsApi,
  postTransactionAssignUserApi,
  getTransactionApi,
  patchTransactionApi,
  getTransactionInstallmentsApi,
  getTransactionContractApi,
  getTransactionSmsCodeApi,
  postTransactionSmsCodeApi,
  getTransactionInfoApi,
  getTransactionDocumentsApi,
  cancelTransactionApi,
  getTransactionValidateEmailApi,
  getTransactionEmailCodeApi,
  postTransactionEmailCodeApi,
  postApproveTransactionApi,
  getTransactionRedirectInstantPaymentApi,
  sendEmailTransactionApi,
} from "../lib/api";

export const GET_TRANSACTIONS = "transaction/GET_TRANSACTIONS";
export const POST_CLIENT_DETAILS = "transaction/POST_CLIENT_DETAILS";
export const GET_TRANSACTION = "transaction/GET_TRANSACTION";
export const GET_INSTALLMENTS = "transaction/GET_INSTALLMENTS";
export const PATCH_TRANSACTION = "transaction/PATCH_TRANSACTION";
export const GET_TRANSACTION_CONTRACT = "transaction/GET_TRANSACTION_CONTRACT";
export const GET_VALIDATE_EMAIL = "transaction/GET_VALIDATE_EMAIL";
export const GET_CODE = "transaction/GET_CODE";
export const POST_CODE = "transaction/POST_CODE";
export const GET_TRANSACTION_INFO = "transaction/GET_TRANSACTION_INFO";
export const GET_TRANSACTION_DOCUMENTS = "transaction/GET_TRANSACTION_DOCUMENTS";
export const CANCEL_TRANSACTION = "transaction/CANCEL_TRANSACTION";
export const POST_APPROVE_TRANSACTION = "transaction/POST_APPROVE_TRANSACTION";
export const GET_REDIRECT_INSTANT_PAYMENT_TRANSACTION = "transaction/GET_REDIRECT_INSTANT_PAYMENT_TRANSACTION";
export const SEND_EMAIL_TRANSACTION = "transaction/SEND_EMAIL_TRANSACTION";


export const getTransaction =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_TRANSACTION,
      dispatch,
      getState,
      apiCall: getTransactionApi,
      apiArgs: [uuid],
      formatResponse: (response) => response.data,
    });
  };

export const patchTransaction =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: PATCH_TRANSACTION,
      dispatch,
      getState,
      spinner: true,
      apiCall: patchTransactionApi,
      apiArgs: [uuid, payload],
      formatResponse: (response) => response.data,
    });
  };

export const getTransactions =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_TRANSACTIONS,
      dispatch,
      getState,
      spinner: true,
      apiCall: getTransactionsApi,
      apiArgs: [uuid],
      formatResponse: (response) => response.data.data,
    });
  };

export const postTransactionAssignUser = (uuid, payload) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: POST_CLIENT_DETAILS,
    dispatch,
    getState,
    spinner: true,
    apiCall: postTransactionAssignUserApi,
    apiArgs: [uuid, payload],
    formatResponse: (response) => response.data.data,
  });
};

export const getTransactionInstallments =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_INSTALLMENTS,
      dispatch,
      getState,
      apiCall: getTransactionInstallmentsApi,
      apiArgs: [uuid],
      formatResponse: (response) => response.data.data,
    });
  };

export const getTransactionContract =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_TRANSACTION_CONTRACT,
      dispatch,
      getState,
      apiCall: getTransactionContractApi,
      apiArgs: [uuid],
    });
  };

export const getTransactionValidateEmail =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_VALIDATE_EMAIL,
      dispatch,
      getState,
      alert: false,
      apiCall: getTransactionValidateEmailApi,
      apiArgs: [uuid],
    });
  };

export const getTransactionEmailCode =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_CODE,
      dispatch,
      getState,
      alert: false,
      apiCall: getTransactionEmailCodeApi,
      apiArgs: [uuid],
    });
  };

export const postTransactionEmailCode =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_CODE,
      dispatch,
      getState,
      alert: false,
      apiCall: postTransactionEmailCodeApi,
      apiArgs: [uuid, payload],
    });
  };

export const getTransactionSmsCode =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_CODE,
      dispatch,
      getState,
      alert: false,
      apiCall: getTransactionSmsCodeApi,
      apiArgs: [uuid],
    });
  };

export const postTransactionSmsCode =
  (uuid, payload) => async (dispatch, getState) => {
    return makeApiCall({
      action: POST_CODE,
      dispatch,
      getState,
      spinner: true,
      alert: false,
      apiCall: postTransactionSmsCodeApi,
      apiArgs: [uuid, payload],
    });
  };

export const getTransactionInfo =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_TRANSACTION_INFO,
      dispatch,
      getState,
      apiCall: getTransactionInfoApi,
      apiArgs: [uuid],
    });
  };

export const getTransactionDocuments =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_TRANSACTION_DOCUMENTS,
      dispatch,
      getState,
      apiCall: getTransactionDocumentsApi,
      apiArgs: [uuid],
      formatResponse: (response) => response.data.data,
    });
  };

export const cancelTransaction =
  (uuid, loggedIn = false) => async (dispatch, getState) => {
    return makeApiCall({
      action: CANCEL_TRANSACTION,
      dispatch,
      getState,
      spinner: true,
      apiCall: cancelTransactionApi,
      apiArgs: [uuid, loggedIn],
      formatResponse: (response) => response.data.data,
    });
  };

export const postApproveTransaction =
  (uuid, payload) => async ( dispatch, getState ) => {
    return makeApiCall({
      action: POST_APPROVE_TRANSACTION,
      dispatch,
      getState,
      spinner: true,
      apiCall: postApproveTransactionApi,
      apiArgs: [uuid, payload],
      formatResponse: (response) => response.data.data,
    });
  };

export const getRedirectInstantPaymentTransaction =
  (uuid) => async (dispatch, getState) => {
    return makeApiCall({
      action: GET_REDIRECT_INSTANT_PAYMENT_TRANSACTION,
      dispatch,
      getState,
      apiCall: getTransactionRedirectInstantPaymentApi,
      apiArgs: [uuid],
      formatResponse: (response) => response.data,
    });
  };

export const sendEmailTransaction =
  (uuid) => async ( dispatch, getState ) => {
    return makeApiCall({
      action: SEND_EMAIL_TRANSACTION,
      dispatch,
      getState,
      apiCall: sendEmailTransactionApi,
      apiArgs: [uuid],
    });
  };

export default (
  state = {
    status: '',
    configInstallments: [],
    tx_type: 4, // temp
  },
  action
) => {
  switch (action.type) {
    case `${GET_TRANSACTION}_SUCCESS`:
      return {
        ...state,
        ...action.payload.data,
      };

    case `${GET_INSTALLMENTS}_SUCCESS`:
      return {
        ...state,
        configInstallments: action.payload,
      };

    default:
      return state;
  }
};
